class AlgaeLaunch extends HTMLElement {
  connectedCallback() {
    this.startCountdown();
    this.setupMediaVideo();
    this.setupReveals();
  }

  disconnectedCallback() {
    if (this.countdownTimer) window.clearInterval(this.countdownTimer);
    document.removeEventListener('visibilitychange', this.resumeMediaVideo);
  }

  setupMediaVideo() {
    const videos = this.querySelectorAll('.algae-launch__media video, .algae-launch__faq-video');
    if (!videos.length) return;

    const playVideos = () => {
      videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.play().catch(() => {});
      });
    };

    videos.forEach((video) => {
      video.addEventListener('loadeddata', playVideos, { once: true });
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.play().catch(() => {});
      });
    });

    this.resumeMediaVideo = () => {
      if (!document.hidden) playVideos();
    };

    playVideos();
    document.addEventListener('visibilitychange', this.resumeMediaVideo);
  }

  startCountdown() {
    const countdown = this.querySelector('[data-algae-countdown]');
    if (!countdown) return;

    const target = new Date(countdown.dataset.target).getTime();
    if (Number.isNaN(target) || target <= Date.now()) {
      countdown.hidden = true;
      return;
    }

    const update = () => {
      const distance = target - Date.now();
      if (distance <= 0) {
        countdown.hidden = true;
        if (this.countdownTimer) window.clearInterval(this.countdownTimer);
        return;
      }
      const values = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance / 3600000) % 24),
        minutes: Math.floor((distance / 60000) % 60),
        seconds: Math.floor((distance / 1000) % 60),
      };

      Object.entries(values).forEach(([unit, value]) => {
        const node = countdown.querySelector(`[data-countdown-${unit}]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });

    };

    update();
    this.countdownTimer = window.setInterval(update, 31);
  }

  setupReveals() {
    const elements = this.querySelectorAll('[data-algae-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach((element) => observer.observe(element));
  }
}

if (!customElements.get('algae-launch')) customElements.define('algae-launch', AlgaeLaunch);
